






































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogNoteOnColumn extends Vue { 
	@Prop() public changeStateTableItem: any
	@Prop() public notifcation: any
	
    dialogCRNote = false
    isReadOnly = false
    txtNote = ""
    title= ""
    columnName = ""
	itemValue = null as any
    itemData = {} as any

    openDialog (item: any, title: string, columnName: string, isReadOnly: boolean = false) {
        this.dialogCRNote = true
        this.columnName = columnName
        this.title = title
        this.itemData = item
        this.txtNote = item[`${columnName}`]
        this.isReadOnly = isReadOnly
    }

    btnSave () {
        this.itemData[`${this.columnName}`] = this.txtNote
        this.changeStateTableItem(this.itemData)
        this.dialogCRNote = false
    }

    btnClose () {
        this.dialogCRNote = false
    }
}
